/**
 * HomeGroupWA Landing Page JS Include (live your dream)
 *
 * @author Red Tiki <info@redtiki.com.au>
 */

window.LandingPageObject = function(opts) {
    var landingpage_obj = {
        init: function() {
            this.bindEvents();
            this.onInit();

            return this;
        },

        bindEvents: function() {
            var self = this;

            $(document).ready(function() {
                self.onReady();
            });
        },

        //event handlers...
        onInit: function() {},
        onReady: function() {
            $('input, textarea').placeholder();

            /*
            $("form").on("submit", function(e){
                e.preventDefault();

                //fire off a tracking events
                if(ga) {
                    ga('send','event','Contact Form','Submit','LandGroup WA');
                }
                if(typeof(goog_report_conversion) === "function"){
                    goog_report_conversion();
                }
                
                this.submit();
                return true;
            });
            */
        },
        onResize: function() {},
        onLoad: function() {}
    };

    if (opts) {
        return $.extend(landingpage_obj, opts);
    } else {
        return landingpage_obj;
    }
};
